var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    transform: "matrix(1 0 0 -1 0 24)",
    fill: "#44494D",
    fillOpacity: 0.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8004 8.33686L11.9478 13.2436L7.19408 8.33686C7.13943 8.27967 7.08479 8.23392 7.02468 8.18817C6.59845 7.89651 6.02467 7.94226 5.65309 8.33686C5.22686 8.78292 5.22686 9.5092 5.65309 9.95527L11.1773 15.6683C11.2046 15.6969 11.232 15.7198 11.2593 15.7427C11.456 15.9085 11.6964 16 11.9533 16C12.2429 16 12.5216 15.8799 12.7238 15.6626L18.3468 9.95527C18.7731 9.5092 18.7731 8.78292 18.3468 8.33686C18.2922 8.27967 18.2375 8.23392 18.1774 8.18817C17.7512 7.89651 17.172 7.94798 16.8004 8.33686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBox);
export default __webpack_public_path__ + "static/media/ArrowDownBox.bf3c960b.svg";
export { ForwardRef as ReactComponent };